module.exports = __webpack_public_path__ + "cd455783/img/send-icon.3cfb6275.svg";